/**
 * Place Overlay Tabs Component
 * Displays tab navigation for Travel Guide and Overview
 * Follows Single Responsibility Principle
 */

import React from 'react';
import {
  typographyColors,
  backgroundColors,
  spacing,
  borders,
  typography,
  fontPrimary,
  brandColors,
} from '@/design-system/utils';

export type TabType = 'guide' | 'overview';

export interface PlaceOverlayTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  className?: string;
}

export const PlaceOverlayTabs: React.FC<PlaceOverlayTabsProps> = ({
  activeTab,
  onTabChange,
  className,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        borderBottom: `${borders.width.thin} solid ${backgroundColors.shade}`,
      }}
      className={className}
    >
      <button
        onClick={() => onTabChange('overview')}
        style={{
          flex: 1,
          backgroundColor: 'transparent',
          border: 'none',
          borderBottom:
            activeTab === 'overview'
              ? `4px solid ${brandColors.primary}`
              : '4px solid transparent',
          padding: spacing[3],
          fontFamily: fontPrimary,
          fontSize: typography.size.lg,
          fontWeight:
            activeTab === 'overview'
              ? typography.weight.semibold
              : typography.weight.regular,
          color: typographyColors.primary,
          cursor: 'pointer',
          textAlign: 'center',
          borderRadius: activeTab === 'overview' ? '3px 3px 0 0' : '0',
        }}
      >
        Overview
      </button>

      <button
        onClick={() => onTabChange('guide')}
        style={{
          flex: 1,
          backgroundColor: 'transparent',
          border: 'none',
          borderBottom:
            activeTab === 'guide'
              ? `4px solid ${brandColors.primary}`
              : '4px solid transparent',
          padding: spacing[3],
          fontFamily: fontPrimary,
          fontSize: typography.size.lg,
          fontWeight:
            activeTab === 'guide'
              ? typography.weight.semibold
              : typography.weight.regular,
          color: typographyColors.primary,
          cursor: 'pointer',
          textAlign: 'center',
          borderRadius: activeTab === 'guide' ? '3px 3px 0 0' : '0',
        }}
      >
        Travel Guide
      </button>
    </div>
  );
};
